export const tokenAddresses = {
  EUL: "0x8e15C8D399e86d4FD7B427D42f06c60cDD9397e7",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x09E6cab47B7199b9d3839A2C40654f246d518a80",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
